import { render, staticRenderFns } from "./vip-dialog.vue?vue&type=template&id=8552a3dc&scoped=true&"
import script from "./vip-dialog.vue?vue&type=script&lang=js&"
export * from "./vip-dialog.vue?vue&type=script&lang=js&"
import style0 from "./vip-dialog.vue?vue&type=style&index=0&id=8552a3dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8552a3dc",
  null
  
)

export default component.exports